import { ListFilter, Search } from 'lucide-react'
import { DataTable } from '../../component/table/dataTable'
import React, { useEffect, useState } from 'react'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu"
import { Input } from "../../component/ui/input";
import { Button } from '../../component/ui/button';
import DataTable2 from '../../component/table/dataTable2';
import { IoAddOutline } from "react-icons/io5";
import { MdEdit, MdOutlineDelete } from 'react-icons/md';
import AddTicker from '../../component/ticker/addTicker';
import AddEmailTemplate from '../../component/email template/addEmailTemplate';
import { deleteEmailTemplate, getAllEmailTemplateDetails, getEmailTemplateInfo, getEmployeeInfo } from '../../utils/util';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loaderSet } from '../../context/actions/loaderAction';
import { setEmailTemplateInfo } from '../../context/actions/emailTemplateInfoAction';
import { alertDanger, alertSuccess } from '../../context/actions/toastAction';
import Loader from '../../component/loader';



const EmailTemplate = ({ employee }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)

  const [addEmailTemplate, setAddEmailTemplate] = useState(false)
  const handleAddEmailTemplate = () => {
    setAddEmailTemplate(true)
  }


  const [AllEmailTemplateDetails, setAllEmailTemplateDetails] = useState()

  const HandleGetAllEmailTemplateDetails = async () => {
    setIsLoading(true)
    const payload = {
      page_no: currentPage,
      per_page: 10,

    }
    try {
      const response = await getAllEmailTemplateDetails(payload)
      console.log("response for get email templatedetails", response)
      if (response && response?.code === 200) {
        setAllEmailTemplateDetails(response?.data?.templates)
        setTotalPage(response?.data?.pagination.total_pages)
        setIsLoading(false)
      }
      else {
        setIsLoading(false)
      }
    } catch (error) {
      console.log("Error in email templateFunctions", error)
      setIsLoading(false)
    }
    // finally {
    //   setTimeout(() => dispatch(loaderSet(false)), 500); // Adds a slight delay
    // }
  }

  const HandleDeleteEmailTemplate = async (data) => {
    setIsLoading(true)
    const payload = {
      template_id: data.template_id
    }
    try {
      const response = await deleteEmailTemplate(payload)
      console.log("Delete response for HandleDeleteEmailTemplate", response)
      if (response.code === 200) {
        dispatch(alertSuccess("Email template deleted successfully"))
        HandleGetAllEmailTemplateDetails()
        setIsLoading(false)
        return
      }
      else {
        dispatch(alertDanger("Error in deleting email template"))
        setIsLoading(false)
      }
    } catch (error) {
      console.log("Error in handle Delete Email Template", error)
      setIsLoading(false)
    }
    // finally {
    //   setTimeout(() => dispatch(loaderSet(false)), 500); // Adds a slight delay
    // }
  }



  const handleEditEmailTemplate = async (data) => {
    setIsLoading(true)
    const payload = { template_id: data.template_id };

    try {
      const response = await getEmailTemplateInfo(payload);
      if (response && response?.code === 200) {
        dispatch(setEmailTemplateInfo(response.data));
        if (response.data && employee) {
          navigate(`/employee/email-template-view?template_id=${data?.template_id}&template_name=${data?.template_name}&action_type=${"Edit"}`);
          return
        }
        if (response.data) {
          navigate(`/admin/email-template-view?template_id=${data?.template_id}&template_name=${data?.template_name}&action_type=${"Edit"}`);
        }
        setIsLoading(false)
      }
      else {
        dispatch(alertDanger(response?.message))
        setIsLoading(false)
      }
    } catch (error) {
      console.error("Error in handleEditEmailTemplate function", error);

      setIsLoading(false)
    }
    //  finally {
    //   setTimeout(() => dispatch(loaderSet(false)), 500); // Adds a slight delay
    // }
  };


  useEffect(() => {
    HandleGetAllEmailTemplateDetails()
  }, [currentPage])


  const buttonOptions = [
    !employee && {
      name: "Delete",
      text: <span className="text-base font-semibold text-sm">Delete</span>,

      icon: <MdOutlineDelete size={15} />,
      actionHandleDeleteEmailTemplate: HandleDeleteEmailTemplate
    },
    {
      name: "Edit",
      text: <span className="text-base font-semibold text-sm">Edit</span>,

      icon: <MdEdit size={15} />,
      actionHandleEditEmailTemplate: handleEditEmailTemplate
    }
  ].filter(Boolean)

  const columns = [
    { id: 'template_name', header: 'Template Name' },
    // { id: 'scheme_name', header: 'Scheme Name' },
    { id: 'created_at', header: 'Created Date' },
    // { id: 'scheme', header: 'Scheme' },
    // { id: 'class', header: 'Class' },
  ];


  const [searchTerm, setSearchTerm] = useState("")
  const searchInputId = "email-template-search";

  const [filteredSchemes, setFilteredSchemes] = useState([])

  useEffect(() => {
    console.log(searchTerm)
    if (searchTerm.length > 0) {
      setFilteredSchemes(AllEmailTemplateDetails.filter((email_template) => {
        const search = searchTerm.toLowerCase();
        return (
          email_template.template_name.toLowerCase().includes(search)


        );
      }))
    }
    else {
      setFilteredSchemes(AllEmailTemplateDetails)
    }

  }, [searchTerm, AllEmailTemplateDetails])


  return (
  <>
  {/* accessiblity fix for silktide issues - H1 heading */}
  <h1 className="sr-only">Email Templates</h1>
  {
  !addEmailTemplate ?
      (location.pathname === "/admin/email-template-view" || location.pathname === "/employee/email-template-view")
        ?
        <>  <AddEmailTemplate forWhichUserType={employee ? "employee" : "admin"} getAllEmailTemplate={HandleGetAllEmailTemplateDetails} back={() => { setAddEmailTemplate(false) }} /></>
        :
        <>

          {
            isLoading && <Loader />
          }

          <div className="w-full flex justify-between items-start p-2 bg-[#FFFFFF] rounded-md">
            <div className="flex w-full justify-end items-center gap-4">

              <div className="flex  gap-2 ">
                <Button variant="outline" size="sm" className="h-10 gap-1 text-sm" onClick={handleAddEmailTemplate} >
                  <IoAddOutline className="h-3.5 w-3.5" />
                  <span className="sr-only sm:not-sr-only">Add Email Template</span>

                </Button>
              </div>

              {/* Search Bar */}
              <div className="flex w-80 gap-2 border-b-2 border-[#0D215C] items-center">
                <label htmlFor={searchInputId} className="sr-only">Search email templates</label>
                <Search className="h-8 w-6 text-muted-foreground pointer-events-none" aria-hidden="true" focusable="false" />
                <Input
                  id={searchInputId}
                  type="search"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  aria-label="Search email templates"
                  className="rounded-none border-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0D215C] text-lg"
                />
              </div>

              {/* Dropdown Menu */}
              {/* <div className="flex items-center gap-2">
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="outline" size="sm" className="h-7 gap-1 text-sm">
                      <ListFilter className="h-3.5 w-3.5" />
                      <span className="sr-only sm:not-sr-only">Filter</span>
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuLabel>Filter by</DropdownMenuLabel>
                    <DropdownMenuSeparator />
                    <DropdownMenuCheckboxItem checked>Fulfilled</DropdownMenuCheckboxItem>
                    <DropdownMenuCheckboxItem>Declined</DropdownMenuCheckboxItem>
                    <DropdownMenuCheckboxItem>Refunded</DropdownMenuCheckboxItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div> */}
            </div>
          </div>


          <div className="w-full bg-[#FFFFFF] mt-4 rounded-md " >
            <DataTable2
              totalPage={totalPage} currentPage={currentPage} setCurrentPage={setCurrentPage}
              //  data={AllEmailTemplateDetails} 
              data={filteredSchemes}
              columns={columns} buttonOptions={buttonOptions} tableFor='Email-Template' /> </div>
        </>
      :
      <>  <AddEmailTemplate forWhichUserType={employee ? "employee" : "admin"} getAllEmailTemplate={HandleGetAllEmailTemplateDetails} back={() => { setAddEmailTemplate(false) }} /></>
	}
      </>

  )
}

export default EmailTemplate
